export const FIRM_SUMMARY_SHEET_TEST_IDS = {
  percentChangeHeader: 'firm-summary__percent-change-from-previous-header',
  percentChangeCell: (companySlug: string) => `firm-summary__percent-change-from-previous-${companySlug}`,
};
